module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "flex": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pt-5": ""
    }
  }, [_c('v-card', [(_vm.logoApp) ? _c('v-card-media', {
    attrs: {
      "src": _vm.logoApp,
      "height": "120px",
      "contain": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('h1', {
    staticClass: "display-1 text-xs-center"
  }, [_vm._v("Dados de Acesso")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-2 my-2 grey lighten-5",
    attrs: {
      "flat": ""
    }
  }, [_c('h1', {
    staticClass: "headline primary--text"
  }, [_vm._v("Paciente: "), _c('b', [_vm._v(_vm._s(_vm.resultado.nomePaciente))])]), _vm._v(" "), _c('h3', {
    staticClass: "subheading primary--text"
  }, [_vm._v("Exame: "), _c('b', [_vm._v(_vm._s(_vm.resultado.tipoExame) + " - " + _vm._s(_vm.resultado.modalidade))])])]), _vm._v(" "), _c('v-form', {
    ref: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['###.###.###-##']),
      expression: "['###.###.###-##']"
    }],
    attrs: {
      "label": "CPF",
      "required": "",
      "rules": [_vm.validarMinimo(_vm.resultado.cpfPaciente, 14), _vm.obrigatorioRules[0]]
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.buscarUsuario($event)
      },
      "change": function($event) {
        _vm.buscouCPF = false
      }
    },
    model: {
      value: (_vm.resultado.cpfPaciente),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "cpfPaciente", $$v)
      },
      expression: "resultado.cpfPaciente"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    attrs: {
      "label": "Email",
      "type": "username",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.usuario.email),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "email", $$v)
      },
      expression: "usuario.email"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    attrs: {
      "label": "Login",
      "disabled": true,
      "type": "username",
      "persistent-hint": true,
      "hint": "Login será os números do CPF",
      "required": ""
    },
    model: {
      value: (_vm.usuario.username),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "username", $$v)
      },
      expression: "usuario.username"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    attrs: {
      "label": "Senha",
      "required": "",
      "rules": _vm.obrigatorioRules,
      "append-icon": _vm.esconderSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.esconderSenha = !_vm.esconderSenha); },
      "type": _vm.esconderSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.usuario.password),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "password", $$v)
      },
      expression: "usuario.password"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) #####-####']),
      expression: "['(##) #####-####']"
    }],
    attrs: {
      "label": "Celular (whatsapp)",
      "type": "username",
      "placeholder": "(##) #####-####",
      "rules": [_vm.validarMinimo(_vm.resultado.telefonePaciente, 15)],
      "hint": "Informe o número do whatsapp"
    },
    model: {
      value: (_vm.resultado.telefonePaciente),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "telefonePaciente", $$v)
      },
      expression: "resultado.telefonePaciente"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-checkbox', {
    attrs: {
      "label": "Autoriza o envio por Whatsapp",
      "disabled": !_vm.whatsapp,
      "color": "green"
    },
    model: {
      value: (_vm.resultado.whatsapp),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "whatsapp", $$v)
      },
      expression: "resultado.whatsapp"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.buscouCPF) ? _c('v-checkbox', {
    attrs: {
      "label": "Autoriza o envio por E-mail",
      "disabled": !_vm.usuario.email,
      "color": "green"
    },
    model: {
      value: (_vm.resultado.enviaEmail),
      callback: function($$v) {
        _vm.$set(_vm.resultado, "enviaEmail", $$v)
      },
      expression: "resultado.enviaEmail"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": ""
    },
    on: {
      "click": _vm.limpar
    }
  }, [_vm._v("limpar")]), _vm._v(" "), (!_vm.buscouCPF) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.buscarUsuario()
      }
    }
  }, [_vm._v("continuar")]) : _vm._e(), _vm._v(" "), (_vm.buscouCPF) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.atualizar()
      }
    }
  }, [_vm._v(_vm._s(_vm.tituloBotaoSubmit))]) : _vm._e(), _vm._v(" "), (_vm.buscouCPF && _vm.resultado.usuario && _vm.resultado.usuario.id) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("visualizar impressão")]) : _vm._e(), _vm._v(" "), (_vm.buscouCPF && _vm.resultado.usuario && _vm.resultado.usuario.id) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v("enviar por email")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.textAlerta) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0546826e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartaoAcesso.vue
// module id = 355
// module chunks = 1